import Pusher from "pusher-js";
import { supabase } from "@/integrations/supabase/client";

let pusherInstance: Pusher | null = null;
let currentKey = "";

/**
 * Get or create the global Pusher instance.
 * Lazy-initializes on first call with valid config.
 */
export function getPusherClient(key: string, cluster: string): Pusher | null {
  if (!key || !cluster) return null;

  // If config changed, disconnect old instance
  if (pusherInstance && currentKey !== key) {
    pusherInstance.disconnect();
    pusherInstance = null;
  }

  if (!pusherInstance) {
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;

    pusherInstance = new Pusher(key, {
      cluster,
      channelAuthorization: {
        endpoint: `${supabaseUrl}/functions/v1/pusher-auth`,
        transport: "ajax",
        customHandler: async (params, callback) => {
          try {
            const { data: { session } } = await supabase.auth.getSession();
            if (!session?.access_token) {
              callback(new Error("Not authenticated"), null);
              return;
            }

            const res = await fetch(`${supabaseUrl}/functions/v1/pusher-auth`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${session.access_token}`,
              },
              body: JSON.stringify({
                socket_id: params.socketId,
                channel_name: params.channelName,
              }),
            });

            if (!res.ok) {
              const err = await res.text();
              callback(new Error(err), null);
              return;
            }

            const data = await res.json();
            callback(null, data);
          } catch (err: any) {
            callback(err, null);
          }
        },
      },
    });

    currentKey = key;
  }

  return pusherInstance;
}

export function disconnectPusher() {
  if (pusherInstance) {
    pusherInstance.disconnect();
    pusherInstance = null;
    currentKey = "";
  }
}
